

import Module, { moduleInit, ViewLayer, bindButtonClickEvent } from "../../../../framework/core/mvvm/module_base";
import { PlayerEffectView } from "./player_effect_view";
const { ccclass, property } = cc._decorator;

enum AnimState{
    None=0,
    Exp= 1<<2,
    Lv = 1<<3,
    ExpFinish = 1<<4,//经验值触发完成
    Game= 1<<5,
}

@ccclass
@moduleInit("PlayerEffectModule")
export default class PlayerEffectModule extends Module<PlayerEffectView, null> {

    protected m_intentData: any = null
    constructor() {
        super();
        this.windowPrefabResPath = "package/table/player_effect";
        this.viewType = PlayerEffectView;
        this.needAnim = false;
        this.needViewMask = false;
        this.clickAnywhereClose = false
    }

    onInit(){
        this.eventBind('Game_Table_Start',this.gameTableStart)
        this.eventBind('Game_Table_Settlement',this.gameSettlement);
        this.eventBind('Event_Notify_UserDetail',this.userDetail)
    }


    gameNode:cc.Node;

    lvData:any;

    expData:any;

    onShow(){
        this.gameTableStart();
        this.isTest =  CC_PREVIEW ? true : false;
    }
    gameSettlement(node:cc.Node){
        this.gameNode = node;
        this.addState(AnimState.Game);
        this.testEffect();
        this.checkCanPlayEffect();
    }

    private isTest:boolean = false;

    stateQue:AnimState[] = [];

    //游戏开始
    gameTableStart(){
       this.stateQue = [];
       this.lvData = null;
       this.expData = null;
    }

    userDetail(data:any){
        if (this.isTest) {
            return;
        }
        if (data.type == 'user_level_up') {//必定条件
            this.lvData = data;
            this.addState(AnimState.Lv);
        }else if (data.type == 'user_exp_detail') {
            this.expData = data;
            this.addState(AnimState.Exp);
        }
        this.checkCanPlayEffect();
    }

    //检测是否播放特效
    checkCanPlayEffect(){
        if (this.isInToState(AnimState.Game)) {//游戏触发了
            
            if (this.isInToState(AnimState.ExpFinish)) {
                if (this.isInToState(AnimState.Lv)) {//触发lv
                    //播放lv动画,完成时检测
                    if (this.gameNodeIsValid() && this.lvData) {
                        this.playSound('sound/public/lvup')
                        this.view.playerLvEffect(this.gameNode,this.lvData,()=>{
                            this.gameTableStart()
                        })
                    }
                }
            }else{
                if (this.isInToState(AnimState.Exp)) {//经验值已经触发
                    this.popState(AnimState.Exp);
                    if (this.gameNodeIsValid() && this.expData) {
                        this.view.playeExpEffect(this.gameNode,this.expData,()=>{
                            this.addState(AnimState.ExpFinish);
                            this.checkCanPlayEffect();
                        })
                    }
                }
            }
        }
    }

    private gameNodeIsValid(){
        if (this.gameNode != null && cc.isValid(this.gameNode, true)) {
            return true;
        }
        return false;
    }

    private addState(state:AnimState){
        if (!this.isInToState(state)) {
            this.stateQue.push(state);
        }
    }

    private popState(state:AnimState){
        for (let i = 0; i < this.stateQue.length; i++) {
            let st = this.stateQue[i];
            if (st == state) {
                this.stateQue.splice(i,1);
            }
        }
    }

    private isInToState(state:AnimState):boolean{
        for (let i = 0; i < this.stateQue.length; i++) {
            let st = this.stateQue[i];
            if (st == state) {
                return true;
            }
        }
        return false;
    }


    private testEffect() {
        if (!this.isTest) {
            return;
        }
        this.addState(AnimState.Lv);
        this.addState(AnimState.Exp);
  
        this.lvData = {
            content:JSON.stringify({
                awardList:[{expAwardNum: 12345}],
                userLevelBefore:8,
                userLevelCurrent:9,})
        }

        this.expData = {
            content:JSON.stringify( {
                incrExp:876,
            })
        }
 
    }
}